<co-chart-card 
    [chartHeader]="chartHeader()" 
    [cssClass]="cssClass()" 
    [filterOptions]="filterOptions()"
    [selectedFilters]="selectedFilters" 
    (onFilterChange)="onDropdownChange()"
    [testResult]="testResult()"
   >
    
    <!-- Table Section -->
    <div chart-content [style.height]="'100%'">
        <!--Export CSV-->
        <div class="mb-3 flex justify-end">
            <button
                type="button"
                class="px-3 py-2 border rounded bg-sky-50 hover:bg-sky-100 text-sm"
                (click)="exportCsv()"
                [disabled]="!tableData || tableData.length === 0"
            >
                {{ "REPORTS.EXPORT_CSV" | translate }}
            </button>
        </div>
        @if (tableData.length) {
            <p-table
                [value]="tableData"
                [paginator]="true"
                [rows]="10"
                [tableStyle]="{ 'min-width': '50rem' }"
                [sortMode]="'multiple'"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="min-width: 500px" />
                    @for(col of tableColumns.slice(1); track col) {
                        <col style="min-width: 120px" />
                    }
                </colgroup>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    @for(col of tableColumns; track col) {
                    <th pSortableColumn="{{ col }}">
                        {{ getColumnLabel(col) | translate }}
                        <p-sortIcon field="{{ col }}"></p-sortIcon>
                    </th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    @for(col of tableColumns; track col) {
                    <td>{{ rowData[col] }}</td>
                    }
                </tr>
                </ng-template>
            </p-table>
        }@else {
            <span>{{ 'REPORTS.NO_DATA_FOUND' | translate }}</span>
        }
    </div>

    <!-- Stats Section -->
    <!-- <div chart-stats>
        @if(chiSquaredResult){
            <div class="mt-6 p-4 rounded-xl bg-gray-50 border border-gray-200">
                <h4 class="text-lg font-semibold mb-2">Chi-Squared Test Result</h4>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><strong>Statistic:</strong> {{ chiSquaredResult.statistic }}</div>
                    <div><strong>P-Value:</strong> {{ chiSquaredResult.pValue }}</div>
                    <div><strong>Alpha:</strong> {{ chiSquaredResult.alpha }}</div>
                    <div><strong>Conclusion:</strong> {{ chiSquaredResult.conclusion }}</div>
                        @if(chiSquaredResult.smallExpectedWarning){
                        <div class="col-span-2 text-yellow-700 text-sm">{{ chiSquaredResult.smallExpectedWarning }}</div>
                        }
                </div>
            </div>
        } @else {
            <div class="text-gray-400 mt-4">Chi-Squared result not available</div>
        }
    </div> -->
  
</co-chart-card>